<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="mb-1 align-items-center">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
        <h1 class="page-title">Orders - Quickbooks
            <span nz-icon nzType="reload" nzTheme="outline" class="reloadDateIcon notPrintable cursor"
                (click)="loadQBOData()" nz-tooltip nzTooltipTitle="Reload Data" nzTooltipPlacement="bottomLeft"></span>
        </h1>
    </div>
    <div class="gutter-row d-flex flex-end" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
        <div class="date-filter-div">
            <input type="text" class="form-control date-picker input mr-1 h-42" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selectedDateRangeQBO" (ngModelChange)="onDateChangeQBO($event)"
                placeholder="Filter By Invoice Date" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true"
                [ranges]="ranges" [opens]="'left'" [showClearButton]="false" [showClearButton]="false">
        </div>
        <div class="filter-icon" nz-popover nzPopoverTitle="Filter By Invoice/BL Status"
            [nzPopoverContent]="contentTemplate" nzPopoverTrigger="click" [(nzPopoverVisible)]="isVisibleQBOFilter"
            nzPopoverPlacement="bottomRight">
            <span nz-tooltip nzTooltipTitle="Filter" nz-icon nzType="filter" nzTheme="outline" class="cursor"></span>
        </div>
        <ng-template #contentTemplate>
            Search By:
            <nz-radio-group [(ngModel)]="radioValueQBO" (ngModelChange)="clearsearchDataQBO()" nzButtonStyle="solid"
                class="mb-1">
                <label nz-radio-button nzValue="A">Invoice Number</label>
                <label nz-radio-button nzValue="B">BL Status</label>
                <label nz-radio-button nzValue="C">Customer Name</label>
            </nz-radio-group>
            <div class="mb-1" *ngIf="radioValueQBO == 'A'">
                <input type="text" class="right_margin search-input" nz-input
                    placeholder="Search invoice number here ..." [(ngModel)]="searchTextInvoice"
                    (keyup)="searchByInvoice()" />
            </div>
            <div class="mb-1" *ngIf="radioValueQBO == 'B'">
                <input type="text" class="right_margin search-input" nz-input placeholder="Search BL status here ..."
                    [(ngModel)]="searchTextBLStatus" (keyup)="searchByBL()" />
            </div>
            <div class="mb-1" *ngIf="radioValueQBO == 'C'">
                <input type="text" class="right_margin search-input" nz-input placeholder="Search customer here ..."
                    [(ngModel)]="searchTextCustomerQB" (keyup)="searchByCustomerQB()" />
            </div>
            <div class="text-right">
                <button class="btn-blue modal-footer-btn" (click)="isVisibleQBOFilter = false;clearsearchDataQBO()"
                    nz-button>Close</button>
            </div>
        </ng-template>
    </div>
</div>
<nz-table class="mb-1" #sortTable [nzData]="quickbooksData" nzTableLayout="fixed" [nzFrontPagination]="false"
    [nzShowPagination]="false" [nzScroll]="quickbooksData.length ? { y : 'calc((100vh - 340px)/2)'} : {}"
    [ngClass]="{'table-loading' : quickbooksData.length > 0 || isLoadingQBOData}">
    <thead>
        <tr class="">
            <th nzWidth="180px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'invoiceDate')">
                Invoice Date
            </th>
            <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'invoiceNumber')">QB
                Invoice#
            </th>
            <th nzWidth="130px" [nzAlign]="'left'">Channel</th>
            <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event,'customerName')">QB Customer
                Name
            </th>
            <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'blStatus')">QB BL
                Status</th>
            <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'po')">PO
            </th>
            <th nzWidth="110px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'shipDate')">QB
                Ship Date
            </th>
            <th nzWidth="113px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'paymentStatus')">
                QB Pmt Status</th>

            <th nzWidth="180px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="SortquickbooksData($event, 'stocks')">Assigned</th>
                <th nzWidth="130px">Action</th>
        </tr>
    </thead>
    <tbody *ngIf="!isLoadingQBOData">
        <ng-container *ngFor="let data of quickbooksData;let i = index;let even=even;">
            <tr>
                <td [nzAlign]="'left'">
                    {{ (data.invoiceDate?.toString() | date : 'MM/dd/yyyy') ==
                    '01/01/0001'? '-' : (data.invoiceDate?.toString() | date : 'MM/dd/yyyy') }}
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.invoiceNumber?.length > 10 ? data.invoiceNumber : ''"><a
                        [href]="data.qboInvoiceDeepLink" [ngClass]="!data.qboInvoiceDeepLink ? 'c-n-allow' : ''"
                        (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null" target="_blank">{{
                        data.invoiceNumber }}</a></td>
                <td [nzAlign]="'left'">
                    <a *ngIf="data.sourceChannel == 'Shopify'" [href]="data.shopifyAdminUrl"
                        [ngClass]="!data.shopifyAdminUrl ? 'c-n-allow' : ''"
                        (click)="!data.shopifyAdminUrl ? $event.preventDefault() : null" target="_blank"
                        nz-tooltip nzTooltipTitle="Open in Shopify Admin">
                        <span class="status-text channel-shopify">Shopify</span></a>
                    <span *ngIf="data.sourceChannel != 'Shopify'" class="status-text"
                        [ngClass]="data.sourceChannel == 'WooCommerce' ? 'channel-woocommerce' : 'channel-other'">{{
                        data.sourceChannel ? data.sourceChannel : '-' }}</span>
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.customerName"> <a [href]="data.zohoContactDeepLink"
                        [ngClass]="!data.zohoContactDeepLink ? 'c-n-allow' : ''"
                        (click)="!data.zohoContactDeepLink ? $event.preventDefault() : null"
                        target="_blank">{{data.customerName}}</a></td>
                <td [nzAlign]="'left'">{{data.blStatus ? (data.blStatus | uppercase) : '-'}} </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.po?.lnegth > 10 ? (data.po) : ''"><a
                        [href]="data.customerName?.toLowerCase() == 'wayfair' ? data.wayfairOrderDeepLink : data.po ? data.woocommerceOrderDeepLink : ''"
                        [ngClass]="!(data.woocommerceOrderDeepLink || data.wayfairOrderDeepLink) || data.po == '' ? 'c-n-allow' : ''"
                        (click)="!(data.woocommerceOrderDeepLink || data.wayfairOrderDeepLink) || data.po == '' ? $event.preventDefault() : null" target="_blank">{{
                        data.po ? (data.po) : '-' }}</a>
                </td>
                <td [nzAlign]="'left'">

                    {{ (data.shipDate?.toString() | date : 'MM/dd/yyyy') ==
                    '01/01/0001'? '-' : (data.shipDate?.toString() | date : 'MM/dd/yyyy') }}
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.paymentStatus?.length > 10 ? (data.paymentStatus) : ''"><span
                        [ngClass]="data.paymentStatus == 'UnPaid' ? 'unpaid' : data.paymentStatus == 'Paid' ? 'paid' : 'partial-paid'"
                        class="status-text">{{
                        data.paymentStatus ? (data.paymentStatus) : '-' }}</span>
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [ngClass]="!data.isAssigned ? 'cursor' : ''"
                    [nzTooltipTitle]="data.stockDetail?.join(',')"><a style="display: contents;"
                        (click)="showAssignmentModal(data, true)">{{ data.isAssigned ? data.stocks : ''}}</a>
                    <button *ngIf="!data.isAssigned" (click)="showAssignmentModal(data)" nz-button nzType="primary"
                        class="right_margin new-btn inline-btn ml-4">Assign</button>
                </td>
                <td nzAlign="center">
                    <!-- Sync shows only where every origin rule passes AND no Shopify order exists yet,
                         i.e. exactly where the Channel column above is blank. `canManualSync` is computed
                         server-side (QboReverseManualSync.CanManualSync) so this template never re-derives
                         the rule; it is a UX hint only, since the endpoint re-checks all of it. -->
                    <button *ngIf="data.canManualSync" nz-button nzType="primary" nzSize="small"
                        class="mr-1"
                        [nzLoading]="isQboSyncing(data)"
                        [disabled]="isQboSyncDisabled(data)"
                        (click)="manualSyncQBOInvoice(data)"
                        nz-tooltip nzTooltipTitle="Create the Shopify order for this invoice">Sync</button>
                    <a [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}" nz-popconfirm
                    nzPopconfirmTitle="Are you sure you want to delete the invoice?"
                    (nzOnConfirm)="deleteQBInvoice(data,i)" [nzIcon]="iconTpl"
                    nzOkText="Yes" nzCancelText="No"
                    [nzPopconfirmTrigger]=" (data.qB_BL_Status | lowercase) == 'shipped' ? null : 'click'"><img
                        [ngClass]="{'disable-icon' : (data.qB_BL_Status | lowercase) == 'shipped'}"
                        class="mr-1 close-icon" src="./assets/images/Close.svg"></a>
                <ng-template #iconTpl>
                    <i nz-icon nzType="question-circle-o" style="color: red;"></i>
                </ng-template>
            </td>
            </tr>
        </ng-container>
    </tbody>
    <ng-container *ngIf="isLoadingQBOData">
        <tbody>
            <tr *ngFor="let i of [].constructor(6)">
                <ng-container *ngFor="let i of [].constructor(10)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
</nz-table>
<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="align-content-center">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
        <div class="d-flex">
            <h1 class="page-title">Orders - {{ radioValueTable == 'S' ? 'Shopify' : radioValueTable == 'A' ? 'WooCommerce' : 'Wayfair'}}
                <span nz-icon nzType="reload" nzTheme="outline" class="reloadDateIcon notPrintable cursor"
                    (click)="radioValueTable == 'S' ? loadShopifyData() : radioValueTable == 'A' ? loadWOOData() : loadWayfairData()" nz-tooltip nzTooltipTitle="Reload Data"
                    nzTooltipPlacement="bottomLeft"></span>
            </h1>
        </div>
    </div>
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" class="mb-1 d-flex flex-end">
        <!--radioValueTable == 'A' ? getWooCommerceData(): getWayfairData()-->
        <nz-radio-group [(ngModel)]="radioValueTable" (ngModelChange)="onOrderTableChange()" nzButtonStyle="solid"
            class="mr-1 custom-radio">
            <label nz-radio-button nzValue="S">Shopify</label>
            <label nz-radio-button nzValue="A">WooCommerce</label>
            <label nz-radio-button nzValue="B">Wayfair</label>
        </nz-radio-group>
        <div class="date-filter-div wooOrderFilter w-37">
            <input type="text" class="form-control date-picker input mr-1 h-42" *ngIf="radioValueTable == 'S'" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selectedDateRangeShopify" (ngModelChange)="onDateChangeShopify($event)"
                placeholder="Filter By Order Date" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true"
                [ranges]="ranges" [opens]="'left'" [showClearButton]="false">
            <input type="text" class="form-control date-picker input mr-1 h-42" *ngIf="radioValueTable == 'A'" [readonly]="true" ngxDaterangepickerMd
                [(ngModel)]="selectedDateRangeWOO" (ngModelChange)="onDateChangeWOO($event)"
                placeholder="Filter By Order Date" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true"
                [ranges]="ranges" [opens]="'left'" [showClearButton]="false">
            <span nz-tooltip nzTooltipTitle="Select From Date"><nz-date-picker class="form-control date-picker input mr-1 h-42 f-19" [nzFormat]="'MM/dd/yyyy'" [nzAllowClear]="false" *ngIf="radioValueTable == 'B'" [(ngModel)]="fromDateWayfair" (ngModelChange)="onDateChangeWayfair($event)" nzPlaceHolder="Select from date"></nz-date-picker></span>
        </div>
        <div class="filter-icon" nz-popover nzPopoverTitle="Filter By Invoice/BL Status"
            [nzPopoverContent]="contentTemplateWoo" nzPopoverTrigger="click" [(nzPopoverVisible)]="isVisibleWOOFilter"
            nzPopoverPlacement="bottomRight">
            <span nz-tooltip nzTooltipTitle="Filter" nz-icon nzType="filter" nzTheme="outline" class="cursor"></span>
        </div>
        <ng-template #contentTemplateWoo>
            Search By:
            <nz-radio-group [(ngModel)]="radioValueWOO" (ngModelChange)="clearsearchDataWOO(getActiveOrderDataType())" nzButtonStyle="solid"
                class="mb-1">
                <label nz-radio-button nzValue="A">Order Number</label>
                <label nz-radio-button nzValue="B" *ngIf="radioValueTable == 'A'">Woo Status</label>
                <label nz-radio-button nzValue="C">Customer Name</label>
            </nz-radio-group>
            <div class="mb-1" *ngIf="radioValueWOO == 'A'">
                <input type="text" class="right_margin search-input" nz-input placeholder="Search order number here ..."
                    [(ngModel)]="searchTextOrder" (keyup)="searchByOrderNumber(getActiveOrderDataType())" />
            </div>
            <div class="mb-1" *ngIf="radioValueWOO == 'B'">
                <input type="text" class="right_margin search-input" nz-input placeholder="Search woo status here ..."
                    [(ngModel)]="searchTextWooStatus" (keyup)="searchByOrderStatus()" />
            </div>
            <div class="mb-1" *ngIf="radioValueWOO == 'C'">
                <input type="text" class="right_margin search-input" nz-input placeholder="Search customer here ..."
                    [(ngModel)]="searchTextCustomerWOO" (keyup)="searchByCustomer(getActiveOrderDataType())" />
            </div>
            <div class="text-right">
                <button class="btn-blue modal-footer-btn" (click)="isVisibleWOOFilter = false;clearsearchDataWOO(getActiveOrderDataType());"
                    nz-button>Close</button>
            </div>
        </ng-template>
    </div>
</div>
<nz-table *ngIf="radioValueTable == 'S'" class="" #shopifyTable [nzData]="shopifyData" nzTableLayout="fixed"
    [nzFrontPagination]="false" [nzShowPagination]="false"
    [nzScroll]="shopifyData.length ? {y: 'calc((100vh - 340px)/2)' } : {}"
    [ngClass]="{'table-loading' : shopifyData.length > 0 || isDataLoadingShopify}">
    <thead>
        <tr>
            <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'orderDate')">Order Date</th>
            <th nzWidth="130px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'orderNumber')">Order Number</th>
            <th nzWidth="170px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'customerName')">Shopify Customer Name</th>
            <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'fulfillmentStatus')">Shopify Status</th>
            <th nzWidth="150px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'qboInvoiceNo')">QB Invoice#</th>
            <th nzWidth="140px" [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="SortShopifyData($event,'paymentType')">Shopify Pmt Type</th>
            <th nzWidth="110px" [nzAlign]="'left'">Action</th>
        </tr>
    </thead>
    <tbody *ngIf="!isDataLoadingShopify">
        <ng-container *ngFor="let data of shopifyData; let i = index;">
            <tr>
                <td [nzAlign]="'left'">{{ (data.orderDate?.toString() | date : 'MM/dd/yyyy') == '01/01/0001' ? '-' : (data.orderDate?.toString() | date : 'MM/dd/yyyy') }}</td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.orderNumber?.length > 10 ? data.orderNumber : ''">
                    <a [href]="data.shopifyAdminUrl" [ngClass]="!data.shopifyAdminUrl ? 'c-n-allow' : ''"
                       (click)="!data.shopifyAdminUrl ? $event.preventDefault() : null" target="_blank">{{ data.orderNumber }}</a></td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.customerName?.length > 10 ? data.customerName : ''">{{ data.customerName }}</td>
                <td [nzAlign]="'left'">{{ data.fulfillmentStatus ? data.fulfillmentStatus : '-' }}</td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.qboInvoiceNo?.length > 10 ? data.qboInvoiceNo : ''">
                    <a [ngClass]="!data.qboInvoiceNo ? 'c-n-allow' : ''"
                       (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null"
                       [href]="data.qboInvoiceDeepLink" target="_blank">{{ data.qboInvoiceNo ? data.qboInvoiceNo : '-' }}</a></td>
                <td [nzAlign]="'left'">{{ data.paymentType ? data.paymentType : '-' }}</td>
                <!-- Sync shows only while the order has no QB invoice. This is a UX hint only: the
                     endpoint re-checks every rule server-side, so a stale row cannot cause a duplicate. -->
                <td [nzAlign]="'left'">
                    <button *ngIf="!data.qboInvoiceNo" nz-button nzType="primary" nzSize="small"
                        [nzLoading]="isSyncing(data)"
                        [disabled]="isSyncDisabled(data)"
                        (click)="manualSyncShopifyOrder(data)">Sync</button>
                    <span *ngIf="data.qboInvoiceNo">-</span>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <ng-container *ngIf="isDataLoadingShopify">
        <tbody>
            <tr *ngFor="let i of [].constructor(10)">
                <ng-container *ngFor="let i of [].constructor(7)">
                    <td [nzAlign]="'left'" class="loading"><div class="bar"></div></td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
</nz-table>
<nz-table *ngIf="radioValueTable == 'A'" class="" #sortTable [nzData]="wooCommerceData" nzTableLayout="fixed"
    [nzFrontPagination]="false" [nzShowPagination]="true"
    [nzTotal]="wooTotal" [nzPageIndex]="wooPageIndex" [nzPageSize]="wooPageSize"
    [nzPageSizeOptions]="[10,25,50,100]" [nzShowSizeChanger]="true"
    (nzPageIndexChange)="onWooPageIndexChange($event)" (nzPageSizeChange)="onWooPageSizeChange($event)"
    [nzScroll]="wooCommerceData.length ? {y: 'calc((100vh - 340px)/2)' } : {}"
    [ngClass]="{'table-loading' : wooCommerceData.length > 0 || isDataLoading}">
    <thead>
        <tr class="">
            <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="onWooSort('date', $event === 'ascend' ? 'asc' : 'desc')">
                Order Date
            </th>
            <th nzWidth="120px" [nzAlign]="'left'" [nzSortFn]="true"
                (nzSortOrderChange)="onWooSort('number', $event === 'ascend' ? 'asc' : 'desc')">
                Order Number
            </th>
            <th nzWidth="170px" [nzAlign]="'left'">
                Woo Customer Name
            </th>
            <th nzWidth="150px" [nzAlign]="'left'">
                Woo Status
            </th>
            <th nzWidth="150px" [nzAlign]="'left'">
                QB Invoice#
            </th>
            <th nzWidth="130px" [nzAlign]="'left'">
                Woo Pmt Type
            </th>
            <th nzAlign="center" nzWidth="150px">Action</th>
        </tr>
    </thead>
    <tbody *ngIf="!isDataLoadingWoo">
        <ng-container *ngFor="let data of wooCommerceData;let i = index;let even=even;">
            <tr>
                <td [nzAlign]="'left'">
                    {{(data.orderDate?.toString() | date : 'MM/dd/yyyy') ==
                    '01/01/0001'? '-'
                    : (data.orderDate?.toString() | date : 'MM/dd/yyyy' )}}
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.orderNumber?.length > 10 ? data.orderNumber : ''"><a
                        (click)="!data.woocommerceOrderDeepLink ? $event.preventDefault() : null"
                        [href]="data?.woocommerceOrderDeepLink"
                        [ngClass]="!data.woocommerceOrderDeepLink ? 'c-n-allow' : ''" target="_blank">{{
                        data.orderNumber }}</a></td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.cutomerName?.length > 10 ? data.cutomerName : ''"><a
                        [ngClass]="!data.zohoCustomerDeepLink ? 'c-n-allow' : ''"
                        (click)="!data.zohoCustomerDeepLink ? $event.preventDefault() : null"
                        [href]="data.zohoCustomerDeepLink" target="_blank">{{data.cutomerName}}</a>
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.orderStatus?.length > 10 ? data.orderStatus : ''">{{
                    data.orderStatus }} </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.qboInvoiceNo?.length > 10 ? data.qboInvoiceNo : ''"><a
                        [ngClass]="!data.qboInvoiceNo ? 'c-n-allow' : ''"
                        (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null"
                        [href]="data.qboInvoiceDeepLink" target="_blank">{{
                        data.qboInvoiceNo ? data.qboInvoiceNo : '-' }}</a>
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.orderPaymentType?.length > 10 ? data.orderPaymentType : ''">
                    {{
                    data.orderPaymentType ?
                    data.orderPaymentType : '-' }}
                </td>
                <td nzAlign="center">
                    <a (click)="$event.stopPropagation()" nz-button nzType="default" class="shipButton"
                        *ngIf="data.sourceChannel != 'Shopify' && data.orderStatus != 'completed'" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to complete the order?" nzCancelText="No"
                        nzOkText="Yes" (nzOnConfirm)="confirmCompletion(data.orderId, i, true, false)">Complete</a>
                    <a (click)="$event.stopPropagation()" nz-button nzType="default" nzOkText="Yes" nzCancelText="No"
                        *ngIf="data.sourceChannel != 'Shopify'"
                        class="shipButton ml-1 cancel-button" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to cancel the order?" nzCancelText="No"
                        nzOkText="Yes" (nzOnConfirm)="confirmCompletion(data.orderId, i,false, true)" nzOkText="Yes" nzCancelText="No">Cancel</a>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <ng-container *ngIf="isDataLoadingWoo">
        <tbody>
            <tr *ngFor="let i of [].constructor(10)">
                <ng-container *ngFor="let i of [].constructor(7)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
</nz-table>
<nz-table *ngIf="radioValueTable == 'B'" class="" #sortTable [nzData]="wayfairData" nzTableLayout="fixed"
    [nzFrontPagination]="false" [nzShowPagination]="false" #wayfairtable
    [nzScroll]="wayfairData && wayfairData.length ? {y: 'calc((100vh - 340px)/2)' } : {}"
    [ngClass]="{'table-loading' : wayfairData.length > 0 || isDataLoading}">
    <thead>
        <tr class="">
            <th
            *ngFor="let column of listOfColumns"
            [nzSortOrder]="column.sortOrder"
            [nzSortFn]="column.sortFn"
            [nzSortDirections]="column.sortDirections"
          >
            {{ column.name }}
          </th>
        </tr>
    </thead>
    <tbody *ngIf="!isDataLoading">
        <ng-container *ngFor="let data of wayfairtable.data;let i = index;let even=even;">
            <tr>
                <td [nzAlign]="'left'">
                    {{(data.orderDate.toString()?.slice(0,-6) | date : 'MM/dd/yyyy') ==
                    '01/01/0001'? '-'
                    : (data.orderDate.toString()?.slice(0,-6) | date : 'MM/dd/yyyy' )}}
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.orderNumber?.length > 10 ? data.orderNumber : ''"><a
                        (click)="!data.wayfairOrderDeepLink ? $event.preventDefault() : null"
                        [href]="data?.wayfairOrderDeepLink"
                        [ngClass]="!data.wayfairOrderDeepLink ? 'c-n-allow' : ''" target="_blank">{{
                        data.orderNumber }}</a></td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.cutomerName?.length > 10 ? data.cutomerName : ''"><a
                        [ngClass]="!data.zohoCustomerDeepLink ? 'c-n-allow' : ''"
                        (click)="!data.zohoCustomerDeepLink ? $event.preventDefault() : null"
                        [href]="data.zohoCustomerDeepLink" target="_blank">{{data.cutomerName}}</a>
                </td>
                <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.qboInvoiceNo?.length > 10 ? data.qboInvoiceNo : ''"><a
                        [ngClass]="!data.qboInvoiceNo ? 'c-n-allow' : ''"
                        (click)="!data.qboInvoiceDeepLink ? $event.preventDefault() : null"
                        [href]="data.qboInvoiceDeepLink" target="_blank">{{
                        data.qboInvoiceNo ? data.qboInvoiceNo : '-' }}</a>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <ng-container *ngIf="isDataLoading">
        <tbody>
            <tr *ngFor="let i of [].constructor(10)">
                <ng-container *ngFor="let i of [].constructor(4)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
</nz-table>


<app-add-update-assignment *ngIf="isAssignmentVisible" [assignemntForInvoice]="assignemntForInvoice"
    [editAssignmentDetail]="editAssignmentDetail" (hideModal)="hideModal($event)">
</app-add-update-assignment>